/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropInPlatformBreakdown
 */
export interface DropInPlatformBreakdown {
    /**
     * 
     * @type {string}
     * @memberof DropInPlatformBreakdown
     */
    platform: string;
    /**
     * 
     * @type {number}
     * @memberof DropInPlatformBreakdown
     */
    sessions: number;
    /**
     * 
     * @type {number}
     * @memberof DropInPlatformBreakdown
     */
    totalHours: number;
}

/**
 * Check if a given object implements the DropInPlatformBreakdown interface.
 */
export function instanceOfDropInPlatformBreakdown(value: object): value is DropInPlatformBreakdown {
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('sessions' in value) || value['sessions'] === undefined) return false;
    if (!('totalHours' in value) || value['totalHours'] === undefined) return false;
    return true;
}

export function DropInPlatformBreakdownFromJSON(json: any): DropInPlatformBreakdown {
    return DropInPlatformBreakdownFromJSONTyped(json, false);
}

export function DropInPlatformBreakdownFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropInPlatformBreakdown {
    if (json == null) {
        return json;
    }
    return {
        
        'platform': json['platform'],
        'sessions': json['sessions'],
        'totalHours': json['totalHours'],
    };
}

export function DropInPlatformBreakdownToJSON(json: any): DropInPlatformBreakdown {
    return DropInPlatformBreakdownToJSONTyped(json, false);
}

export function DropInPlatformBreakdownToJSONTyped(value?: DropInPlatformBreakdown | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['platform'],
        'sessions': value['sessions'],
        'totalHours': value['totalHours'],
    };
}

